export default "/images/ab7b12d80b4bd5b2105398de8f9fb0e0.avif";